const routes = {
  home: {
    rawPath: '/',
    path: () => '/'
  },

  authentication: {
    signup: {
      rawPath: '/authentication/signup',
      path: () => '/authentication/signup'
    },
    login: {
      rawPath: '/authentication/login',
      path: () => '/authentication/login'
    },
    forgotPassword: {
      rawPath: '/authentication/forgotPassword',
      path: () => '/authentication/forgotPassword'
    },
    confirmCode: {
      rawPath: '/authentication/confirmCode',
      path: (email: string) => `/authentication/confirmCode?email=${email}`
    },
    resetPassword: {
      rawPath: '/authentication/resetPassword',
      path: (email: string) => `/authentication/resetPassword?email=${email}`
    },

    onboardingUserType: {
      rawPath: '/authentication/userType',
      path: () => '/authentication/userType'
    },
    onboardingProfile: {
      rawPath: '/authentication/profile',
      path: () => '/authentication/profile'
    },
    onboardingPayment: {
      rawPath: '/authentication/payment',
      path: () => '/authentication/payment'
    },
    onboardingComplete: {
      rawPath: '/authentication/complete',
      path: () => '/authentication/complete'
    }
  },

  myProfile: {
    rawPath: '/myProfile',
    path: () => '/myProfile'
  },

  investorProfile: {
    rawPath: '/investor/:userId',
    path: (userId: string) => `/investor/${userId}`
  },

  pitchDecks: {
    rawPath: '/pitchDecks',
    path: () => '/pitchDecks',

    group: {
      rawPath: '/pitchDecks/:group',
      path: (group?: string) => {
        if (!group) return '/pitchDecks';
        return `/pitchDecks/${group}`;
      }
    },

    title: {
      rawPath: '/pitchDecks/:group/:title',
      path: (group?: string, title?: string) => {
        if (!group) return '/pitchDecks';
        if (!title) return `/pitchDecks/${group}`;
        return `/pitchDecks/${group}/${title}`;
      }
    }
  },

  investors: {
    rawPath: '/investors',
    path: () => '/investors'
  },

  myFundraises: {
    rawPath: '/myFundraises',
    path: () => '/myFundraises'
  },

  fundraise: {
    rawPath: '/fundraise/:id',
    path: (id: string) => `/fundraise/${id}`
  },

  legal: {
    rawPath: '/legal',
    path: () => '/legal',

    documents: {
      rawPath: '/legal/documents',
      path: () => '/legal/documents'
    }
  },

  beforeAndAfter: {
    rawPath: '/beforeAndAfter',
    path: () => '/beforeAndAfter'
  },

  debug: {
    rawPath: '/debug',
    path: () => '/debug'
  },

  superAdmin: {
    auth: {
      rawPath: '/superAdmin/auth',
      path: () => '/superAdmin/auth'
    },

    dashboard: {
      rawPath: '/superAdmin/dashboard',
      path: (tab: 'investors' | 'startups' | 'investmentAreas' | 'accessPasses' | 'appSettings') => `/superAdmin/dashboard?tab=${tab}`
    },

    profile: {
      rawPath: '/superAdmin/profile',
      path: () => '/superAdmin/profile'
    }
  }
};

export default routes;
